import api, { API_VERSIONS } from "@/config/api";
import { recoverTokenInfo } from "../utils/recoverTokenInfo";
import { type Recording } from "@/models/recording";

export type RecordItems = {
  items: Recording[];
  totalItems: number;
  currentPage: number;
  pageSize: number;
  totalPages: number;
};

export const getRecordsLibrary = async (params: {
  [key: string]: string | number;
}) => {
  const initialToken = recoverTokenInfo();

  if (!initialToken) return;

  const response = await api.get<RecordItems>(`/${API_VERSIONS.v0}/recording`, {
    headers: {
      Authorization: `Bearer ${initialToken}`,
    },
    params: {
      ...params,
    },
  });

  if (!response.data) return;

  return { ...response.data, items: response.data.items ?? [] };
};
